import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";
import fetch from "isomorphic-fetch"; //适配ie,不要删除
import VueLazyload from "vue-lazyload";
import "./App.scss";
import "./assets/iconfont/iconfont.css";
import "./element-variables.scss";
import { goAnchor } from "./utils/tool.js";

Vue.use(VueLazyload, {
  loading: "/preload.jpg",
  error: "/preload.jpg",
});
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  watch: {
    $route(newVal, oldVal) {
      if (newVal.params.anchor) {
        this.goAnchor(newVal.params.anchor);
      }
    },
  },
  mounted() {
    //解决跳转到新页面不默认固定在顶部的bug
    document.dispatchEvent(new Event("render-event"));
  },
  methods: {
    goAnchor,
  },
  render: (h) => h(App),
}).$mount("#app");
